import { IEnvironment } from "./IEnvironment";

export const environment = {
    emailRecipient: 'insidesalestestleads@cinchhs.com',
    emailSubjectPrefix: 'DTC CE cross sale test',
    footerBaseUrl:{
        withOutHeaderLink:'/',
        withHeaderLink:'https://cinchhomeservices.com/',
        doNotSellUrl: 'https://cinchhomeservices.com/ca-privacy-choices'
    },
    SrgOrTxSrgServiceProviders:{
        Srg:'700002038', //for lower environments
        TxSrg: '700002042'
    },
    pazeUrl: 'https://checkout.wallet.cat.earlywarning.io/web/resources/js/digitalwallet-sdk.js',
    pazeClient: {
        "client": {
            "id": "EO4S9D41KVXSSG9MY5WA13-aqH0QHUi2HDMYNCIvYKkAD9_aM",
            "name": "Cinch",
            "profileId": "Cinch"
        }
    },
    msClarityProjectId: 'qnm1428a3z',
    hotJarProjectId: '5335614',
    cxOneGuideInitId: 'fbe884de-4343-4219-8f9b-239e9f4c826f',
    spCompeteServiceProvider: '700002184',
    procureVendorServiceProvider:'SNAD DISPATCH REQUEST',
    roofLeakServiceProvider:'700002269',
    realEstateRenewalBaseUrl: 'https://uat.enroll.cinchhomeservices.com',
}